// We use a custom breakpoint here as the default desktop breakpoint (1024px) is too narrow for this component
export const EXTRA_L_MIN_BREAKPOINT = `1280px`
